var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconLogo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 151,
    height: 150,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M71.516 75.727v46.012a5.824 5.824 0 01-5.829 5.819h-9.876a.583.583 0 01-.584-.582V80.964a5.823 5.823 0 015.83-5.819h9.876c.322 0 .583.262.583.582z",
    fill: "url(#icon_logo_svg__paint0_linear)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M44.068 6.105v53.854c0 .32-.26.582-.583.582h-9.937a5.824 5.824 0 01-5.83-5.82V.869c0-.322.259-.58.583-.58h9.936a5.822 5.822 0 015.83 5.817z",
    fill: "url(#icon_logo_svg__paint1_linear)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M44.068 102.767v41.394c0 3.212-2.609 5.817-5.831 5.817h-9.936a.58.58 0 01-.583-.582v-41.392a5.823 5.823 0 015.83-5.819h9.937c.324 0 .583.262.583.582z",
    fill: "url(#icon_logo_svg__paint2_linear)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.302 117.004v27.156a5.822 5.822 0 01-5.827 5.818H.583a.581.581 0 01-.583-.582v-27.157a5.825 5.825 0 015.83-5.819h9.89c.323 0 .582.262.582.584z",
    fill: "url(#icon_logo_svg__paint3_linear)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M71.516 28.547v23.589c0 .321-.259.583-.583.583h-9.876a5.823 5.823 0 01-5.83-5.819V23.31c0-.32.261-.582.584-.582h9.876a5.825 5.825 0 015.83 5.819z",
    fill: "url(#icon_logo_svg__paint4_linear)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M16.302 6.107v27.16c0 .322-.259.582-.583.582H5.831C2.61 33.85 0 31.244 0 28.034V.87C0 .55.26.29.583.29h9.892a5.821 5.821 0 015.827 5.817z",
    fill: "url(#icon_logo_svg__paint5_linear)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M150.001 149.418v-38.673c0-3.703-1.473-7.255-4.095-9.874L131.611 86.61a14.008 14.008 0 00-9.89-4.089h-38.75c-.32 0-.582.26-.582.582v38.672a13.95 13.95 0 004.097 9.875l14.292 14.26a14 14 0 009.89 4.09h38.75a.583.583 0 00.583-.582z",
    fill: "url(#icon_logo_svg__paint6_linear)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M150.001.582v38.673c0 3.703-1.473 7.255-4.095 9.874L131.611 63.39a14.008 14.008 0 01-9.89 4.089h-38.75a.583.583 0 01-.582-.582V28.225a13.95 13.95 0 014.097-9.875l14.292-14.26a13.998 13.998 0 019.89-4.09h38.75c.323 0 .583.262.583.582z",
    fill: "url(#icon_logo_svg__paint7_linear)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "icon_logo_svg__paint0_linear",
    x1: 53.593,
    y1: 75.315,
    x2: 78.719,
    y2: 125.09,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D9D9D9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "icon_logo_svg__paint1_linear",
    x1: 26.077,
    y1: 0.484,
    x2: 57.189,
    y2: 54.298,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D9D9D9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "icon_logo_svg__paint2_linear",
    x1: 26.077,
    y1: 102.34,
    x2: 47.657,
    y2: 149.398,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D9D9D9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "icon_logo_svg__paint3_linear",
    x1: -1.636,
    y1: 116.529,
    x2: 10.058,
    y2: 152.742,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D9D9D9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "icon_logo_svg__paint4_linear",
    x1: 53.593,
    y1: 22.826,
    x2: 63.121,
    y2: 55.813,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D9D9D9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "icon_logo_svg__paint5_linear",
    x1: -1.636,
    y1: 0.399,
    x2: 10.059,
    y2: 36.614,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D9D9D9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "icon_logo_svg__paint6_linear",
    x1: 75.602,
    y1: 82.74,
    x2: 87.891,
    y2: 161.229,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D9D9D9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "icon_logo_svg__paint7_linear",
    x1: 150.001,
    y1: 0,
    x2: 82.523,
    y2: 67.612,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#89DD65"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AEDD65"
  })))));
}

export default SvgIconLogo;